<ng-container *ngIf="(cExts$ | async) as exts">
  <div class="grid-container">
    <app-generic-list
      [canRefresh]="false"
      [dataSource]="exts.extProfils"
      keyExpr="key_name"
      [canExportExcel]="true"
      [columns]="columns"
    >
    </app-generic-list>
  </div>
</ng-container>
